"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardTypeToJSON = exports.RewardTypeFromJSONTyped = exports.RewardTypeFromJSON = exports.RewardType = void 0;
/**
 * Type of reward to payout.
 * @export
 * @enum {string}
 */
var RewardType;
(function (RewardType) {
    RewardType["FUEL"] = "FUEL";
    RewardType["NFT"] = "NFT";
    RewardType["PROMO"] = "PROMO";
    RewardType["PROMOTOKEN"] = "PROMO_TOKEN";
    RewardType["MERCH"] = "MERCH";
    RewardType["GIFTCARD"] = "GIFT_CARD";
    RewardType["XP"] = "XP";
    RewardType["XPMULTIPLIER"] = "XP_MULTIPLIER";
    RewardType["LEADERBOARDPOINTS"] = "LEADERBOARD_POINTS";
    RewardType["OTHER"] = "OTHER";
})(RewardType = exports.RewardType || (exports.RewardType = {}));
function RewardTypeFromJSON(json) {
    return RewardTypeFromJSONTyped(json, false);
}
exports.RewardTypeFromJSON = RewardTypeFromJSON;
function RewardTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.RewardTypeFromJSONTyped = RewardTypeFromJSONTyped;
function RewardTypeToJSON(value) {
    return value;
}
exports.RewardTypeToJSON = RewardTypeToJSON;
